import React from 'react';
import './LanguageToggle.css';

interface LanguageToggleProps {
    language: 'fi' | 'en';
    onToggle: (lang: 'fi' | 'en') => void;
}

const LanguageToggle: React.FC<LanguageToggleProps> = ({ language, onToggle }) => {
    return (
        <div className="language-toggle">
            <button onClick={() => onToggle(language === 'fi' ? 'en' : 'fi')}>
                {language === 'en' ? 'FI' : 'EN'}
            </button>
        </div>
    );
};

export default LanguageToggle;
